import { ChangeDetectorRef, Directive, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from 'rxjs/operators';
import { Sezione } from "src/app/common/models/sezioni/sezione";
import { TipoSezione } from "src/app/common/models/tipologiche/tipo-sezione";

import { FrontEndMapping } from "../../../../core/configuration/front-end-mapping";
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { ServicePathsSettings } from "../../../../core/configuration/service-paths-settings";
import { UrlSettingsCore } from "../../../../core/configuration/url-settings-core";
import { FascicoliMappingService } from "../../../../core/services/fascicoli-mapping.service";
import { OperationsService } from "../../../../core/services/operations.service";
import { RoutingConfigurationUtilService } from "../../../../core/services/routing-configuration-util.service";
import { ViewManagerService } from "../../../../core/services/view-manager-service";
import { IdCampiCtxMenu } from "../../../configuration/id-campi-ctx-menu";
import { MenuActions } from "../../../configuration/menu-actions";
import { IdDescrittoriDiSezione, NomiDescrittoriSezione, } from "../../../configuration/nomi-descrittori-sezione";
import { IntestazioneFascicoloInterface } from "../../../interface/intestazione-fascicolo-interface";
import { CtxBodyAbstract } from "../../../models/ctx-body-abstract";
import { CtxBodyFascicolo } from "../../../models/ctx-body-fascicolo";
import { CtxBodyFascicoloIns } from "../../../models/ctx-body-fascicolo-ins";
import { CtxMessage } from "../../../models/ctx-message";
import { DescrittoreSezione } from "../../../models/descrittore-sezione";
import { DocumentoAllegato } from "../../../models/documento-allegato";
import { DataInput } from "../../../models/dto/data-input";
import { FileUploadResponse } from "../../../models/dto/file-upload-response";
import { UpdateMetadatiDocumentoRequest } from "../../../models/dto/update-metadati-documento-request";
import { FascicoloFull } from "../../../models/fascicolo/fascicolo-full";
import { FileData } from "../../../models/file-data";
import { IntestazioneFascicoloService } from "../../../services/intestazione-fascicolo-service";
import { DocumentoAddModal } from "../../documenti/documento-add/documento-add-modal.component";
import {
  DocumentVersionHistoryModal
} from "../../documenti/documento-history-version/document-version-history-modal.component";
import { DocumentoSpostaCategoriaModal } from "../../documenti/documento-sposta/documento-sposta-modal.component";
import {
  DocumentUpdateMetadatiModal
} from "../../documenti/documento-update-metadati/document-update-metadati-modal.component";
import {
  DocumentVersionUpdateModal
} from "../../documenti/documento-version-update/document-version-update-modal.component";
import { ProtocollaDocumentoModalComponent } from "../../documenti/protocolla-documento/protocolla-documento-modal.component";
import { DetailFolderFileComponent } from "../../treeview-component/detail-folder-file/detail-folder-file.component";
import { ResponseDocumentProtocol } from "src/app/common/protocol/models/dto/response-document-protocol";
import { HelpersService } from "src/app/core/services/helpers.service";
import { ModalNotifyService } from "src/app/core/services/modal-notify.service";
import { HttpResponse } from "@angular/common/http";
import { saveAs } from 'file-saver';

import { DialogService } from "src/app/core/components/dialog/dialog.service";
import { ProtocolDocumentSelectionComponent } from "src/app/common/protocol/components/protocol-document-selection/protocol-document-selection.component";
import { ProtocolFascicoloInsertComponent } from "src/app/common/protocol/components/fascicolo/insert/protocol-fascicolo-insert.component";
import { ProtocolService } from "src/app/common/protocol/services/protocol.service";
import { ConfirmModalComponent } from "src/app/core/components/dialog/components/confirm-modal/confirm-modal.component";
import { TipoDocumento } from "src/app/common/models/tipologiche/tipo-documento";
import { FormBuilder, FormGroup } from "@angular/forms";
import { FormFieldBase, FormFieldType } from "../../dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import { QuestionBase } from "src/app/core/components/dynamic-form/models/question-base";
import { QuestionControlService } from "src/app/core/components/dynamic-form/services/question-control.service";
import { Pagination } from "src/app/common/models/pagination";
import { SignDocumentDialogComponent } from "src/app/common/sign/document/components/dialog/sign-document-dialog.component";
import { MarkDocumentDialogComponent } from "src/app/common/mark/document/components/dialog/mark-document-dialog.component";
import { EXTENSIONS, mimeExtensionMap } from "../../file-preview/eml/eml-preview.component";
import { UserProfileFlagStore } from "src/app/utility/store/user-profile-flag";
import { environment } from "src/environments/environment";
import { AnnullaDocumentoProtocolloComponent } from "src/app/common/protocol/components/fascicolo/dialog/annulla-documento-protocollo/annulla-documento-protocollo.component";
import { SelezioneFascicoliSecondariComponent } from "src/app/common/protocol/components/fascicolo/dialog/selezione-fascicoli-secondari/selezione-fascicoli-secondari.component";
import { ConfigurationService } from "src/app/common/configuration/services/configuration.service";
import { ConfigurationFeature } from "src/app/common/configuration/models/configuration";
import { UpdateMetadatiComponent } from "./metadati/update-metadati/update-metadati.component";


declare var openModal: any;
declare var closeModal: any;
export class TreeModel {
  constructor(
    public cid: string = "code",
    public lid: string = "label",
    public cnid: string = "children",
    public items: FileFolders[] = [],
    public className: any = null,
    public showTitle: boolean = true,
    public treeTitle: string = "",
    public treeNodeId: string = "",
    public iconExpand: string = "glyphicon-folder-close",
    public iconCollapse: string = "glyphicon-folder-open",
    public iconNeutral: string = "glyphicon-file"
  ) {}
}

export class FileFolders {
  constructor(
    public name: string = "",
    public code: string = "",
    public children: FileFolders[] = [],
    public root: boolean = false,
    public path: string = "file.jpg",
    public dateMod: string = "01/01/1980",
    public documento: DocumentoAllegato = new DocumentoAllegato(),
    public section: Sezione = null
  ) {}
}

@Directive()
export abstract class DocumentazioneAllegataComponent
  implements OnInit, OnDestroy, IntestazioneFascicoloInterface
{
  @ViewChild('docShowDetailModal') docShowDetailModal!: ElementRef<HTMLDivElement>;
  @ViewChild('docShowEliminaDirModal') docShowEliminaDirModal!: ElementRef<HTMLDivElement>;
  @ViewChild("docVersionUpdateModal")
  docVersionUpdateModal: DocumentVersionUpdateModal;
  @ViewChild("docVersionHistory")
  docVersionHistoryModal: DocumentVersionHistoryModal;
  @ViewChild("docAddModal") docAddModal: DocumentoAddModal;
  @ViewChild("docSpostaModal") docSpostaModal: DocumentoSpostaCategoriaModal;
  @ViewChild("docUpdateMetadatiModal")
  docUpdateMetadatiModal: DocumentUpdateMetadatiModal;
  @ViewChild("docProtocolModal")
  docProtocolModal: ProtocollaDocumentoModalComponent;
  @ViewChild('detailFolder') detailDocument: DetailFolderFileComponent;
  @Input() fascicolo: any;
  addDocFormTitles: Array<string> = [];
  subscriptionFascicolo: Subscription;
  subscriptionIntestazioneFascicolo: Subscription;
  subscriptionListDocumentazione: Subscription;
  ctxBodyFascicolo: CtxBodyFascicolo;
  descrittoriSezione: DescrittoreSezione[];
  sezioni: Array<any> = new Array();
  readUrlArray: Array<string>;
  insertUrlArray: Array<string>;
  deleteUrlArray: Array<string>;
  addDocToEntity: boolean = false;
  // titolo principale della pagina
  titlePrincipal: string;
  listDocumentazione;
  // variabili per wizard
  wizard: boolean;
  mandatoryNotCompiled: number;
  nextStepWizard: string;
  addDocumentFormTitleArray: Array<string>;
  urlConcludiInserimento: string;
  nomePagina: string;
  tipoPratica: string;
  subscriptionctxMenuSezioni: Subscription;
  titleSection: string;
  titleControparti: string = "Parte";
  titleAltreParti: string = "Altre parti";
  titleScadenze: string = "Adempimenti";
  idFascicolo: string = "";
  demoData: TreeModel;
  treeData: FileFolders[] = [];
  itemSelected: FileFolders;
  separatorePathLogico: string;
  docToMove: FileFolders;
  fileFoldersTo: FileFolders;
  refreshData: boolean;
  XSRF: string;
  public loading: boolean;
  public fileData: FileData = new FileData();
  fileUploadList: DocumentoAllegato[] = [];
  searchIdDoc: string = "";
  esn: string;
  isMovingFolder: boolean;
  subscription: Subscription;
  refDocumentaleZip: string;
  downloadPolling:any;
  isSpinning: boolean = false;
  
  tipiDocumentoOptions: TipoDocumento[] = [];
  filterForm!: FormGroup;
  questions: FormFieldBase[];
  docList = [];
  currentDocList = [];
  filters: { [key: string]: string } = {}; // Filtri attivi
  tempDocList = []; // Input temporanei
  itemsPerPage = 10; // Numero di elementi per pagina
  currentPage = 0; // Pagina attuale
  sortDirection: 'asc' | 'desc' = 'asc';
  sortColumnKey: string = '';
  showDetail: boolean;
  isEliminaDir: boolean;
  docToDetail: DocumentoAllegato;
  docToRemove: DocumentoAllegato;
  dirToRemove;
  docListLength: number = null;
  pagination: Pagination;
  cartellaCorrente:any;
  abstract getTipoFascicolo(): any;
  abstract getTipoPratica(): any;
  abstract getUrlRemoveDocFromDocumentazioneAllegata();
  abstract getUrlAddDocToDocumentazioneAllegata();
  abstract getUrlReadSezione(): Array<string>;
  abstract getTitlePrincipal(): string;
  abstract getNextStepWizard(): string;
  abstract isWizard(): boolean;
  abstract getUrlAssegnazioneSmistamento(): string;
  abstract getUrlConcludiSmistamento(): string;
  downloadState: 'nessuno' | 'in_corso' | 'completo' = 'nessuno';
  isDownloadEnabled: boolean = false;

  constructor(
    private viewManager: ViewManagerService,
    private activatedRoute: ActivatedRoute,
    private operationService: OperationsService,
    private routingService: RoutingConfigurationUtilService,
    private intestazioneFascicoloService: IntestazioneFascicoloService,
    protected fascicoliMappingService: FascicoliMappingService,
    private frontEndMapping: FrontEndMapping,
    private modalNotifyService: ModalNotifyService,
    private dialog: DialogService,
    private protocolservice: ProtocolService,
    private helpers: HelpersService,
    private qcs: QuestionControlService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private configService: ConfigurationService
  ) {
    // this.readUrlArray = this.getUrlReadSezione();
    this.insertUrlArray = this.getUrlAddDocument();
    this.deleteUrlArray = this.getUrlRemoveDocFromSezione();
    // this.addDocFormTitles = this.getAddDocumentFormTitle();
    // this.addDocumentFormTitleArray = this.getAddDocumentFormTitle();
    this.subscriptionctxMenuSezioni = this.viewManager.ctxMenuSezioni.subscribe(
      (res) => {
        // debugger;
        this.titleSection =
          this.fascicoliMappingService.getLabelMenuBySectionFascicolo(
            this.isWizard() ? res.lowerList : res.upperList,
            "documentazione_allegata_fascicolo"
          );
        this.titleControparti =
          this.fascicoliMappingService.getLabelMenuBySectionFascicolo(
            this.isWizard() ? res.lowerList : res.upperList,
            "controparti_fascicolo"
          );
        this.titleScadenze =
          this.fascicoliMappingService.getLabelMenuBySectionFascicolo(
            this.isWizard() ? res.lowerList : res.upperList,
            "scadenzario_fascicolo"
          );
        this.titleAltreParti =
          this.fascicoliMappingService.getLabelMenuBySectionFascicolo(
            this.isWizard() ? res.lowerList : res.upperList,
            "altre_parti_fascicolo"
          );
        this.addDocFormTitles = this.getAddDocumentFormTitle();
        this.addDocumentFormTitleArray = this.getAddDocumentFormTitle();
      }
    );
  }
  ngOnInit() {
    this.readUrlArray = this.getUrlReadSezione();
    this.isDownloadEnabled = this.configService.isFeatureEnabled(ConfigurationFeature.MASSIVE_DOWNLOAD_DOCUMENT);
    this.viewManager.initializeBody();
    this.wizard = this.isWizard();
    this.frontEndMapping
      .getListTipiPratica(this.getTipoPratica())
      .subscribe((res) => {
        this.tipoPratica = res; // FrontEndMapping.tipiPratica[this.getTipoPratica()];
      });
    this.fascicoliMappingService.getAllTipiFascicolo().subscribe((list) => {
      this.titlePrincipal = this.getTitlePrincipal();
    });
    this.subscriptionFascicolo = this.viewManager.ctxBody.subscribe(
      (ctxBodyAbstract) => this.ctxBodyTaked(<CtxBodyFascicolo>ctxBodyAbstract)
    );
    this.subscriptionIntestazioneFascicolo =
      this.intestazioneFascicoloService.notifyActionIntestazione.subscribe(
        (fascicoloFull) => this.fascicoloRefreshed(fascicoloFull)
      );
      this.subscriptionListDocumentazione = this.viewManager.documentazione$.subscribe(
        (documenti) => {
          if(this.idFascicolo)  {
            this.getListDocumentazione();
            const idSezione = this.ctxBodyFascicolo?.fascicolo?.idSezioneDocumentazioneAllegata;
              this.readSezione(
              this["readUrlArray"]["idSezioneDocumentazioneAllegata"],
              idSezione,
              "SezioneDocumentazioneAllegata"
            );
          }
        }
      );
    this.nomePagina = UrlSettingsCore.URL_VISUALIZZA_SEZIONE_DOCUMENTAZIONE_ALLEGATA;
    this.helpers.getTipiDocumenti().subscribe(response => {
      this.tipiDocumentoOptions = response && response.length > 0 ? (response.sort((a, b)=>(a.label < b.label ) ? -1 : 1)) : []
      this.initForm();
    });
    if (!this.wizard) {
      this.activatedRoute.params.subscribe((params: Params) => {
        this.fascicoliMappingService.getAllTipiFascicolo().subscribe((res) => {
          let msg: CtxMessage = new CtxMessage(
            MenuActions.VISUALIZZA_FASCICOLO,
            this.getTipoPratica(),
            this.getTipoFascicolo(),
            params["idFascicolo"],
            IdCampiCtxMenu.DOCUMENTAZIONE_ALLEGATA_FASCICOLO
          );
          this.viewManager.disegnaMenu(msg);
        });
        this.idFascicolo = params["idFascicolo"];
      });
    } else {
      this.subscriptionFascicolo = this.viewManager.ctxBody.subscribe(
        (ctxBodyAbstract) =>
          (this.mandatoryNotCompiled = (<CtxBodyFascicoloIns>(
            ctxBodyAbstract
          )).statoInserimento.mandatoryNotCompiled)
      );
      this.activatedRoute.params.subscribe((params: Params) => {
        this.fascicoliMappingService.getAllTipiFascicolo().subscribe((res) => {
          let msg: CtxMessage = new CtxMessage(
            MenuActions.INSERISCI_FASCICOLO,
            this.getTipoPratica(),
            this.getTipoFascicolo(),
            params["idFascicolo"],
            IdCampiCtxMenu.DOCUMENTAZIONE_ALLEGATA_FASCICOLO_INS
          );
          this.viewManager.disegnaMenu(msg);
        });
        this.idFascicolo = params["idFascicolo"];
      });
    }
    this.urlConcludiInserimento = this.getUrlConcludiSmistamento();
    this.activatedRoute.queryParams
      .pipe(
        filter((params) => params.idDoc)
      )
      .subscribe((params) => {
        this.searchIdDoc = params.idDoc;
      });
      this.checkDownloadStatus();
  }

  startRefreshSpin() {
    this.isSpinning = true;
    this.checkDownloadStatus();
  }

  checkDownloadStatus() {
    this.operationService.checkDownloadStatus(this.idFascicolo).subscribe(response => {
        if (response?.stato === 'COMPLETO') {
          this.downloadState = 'completo';
          this.refDocumentaleZip = response.refDocumentale;
          clearInterval(this.downloadPolling);
        } else if (response?.stato === 'APERTO' || response?.stato === 'IN_CORSO' ) {
          this.downloadState = 'in_corso';
          if (!this.downloadPolling) {
            this.startDownloadPolling();
          }
      } else {
        this.downloadState = 'nessuno';
        clearInterval(this.downloadPolling);
      }
    });
  }

  requestDownload() {
    this.operationService.requestDownload(this.idFascicolo).subscribe(response => {
      if (response?.stato === 'APERTO' || response?.stato === 'IN_CORSO') {
        this.downloadState = 'in_corso';
        // Inizia il polling per verificare lo stato del download
        this.startDownloadPolling();
      }
    });
  }

  startDownloadPolling() {
    // Esegui il polling ogni 30 secondi
    this.loading = false;
    this.downloadPolling = setInterval(async () => {
      await this.checkDownloadStatus();
    }, 30000);
  }

  scaricaTuttiIDocumenti() {
    if (this.downloadState === 'completo' && this.refDocumentaleZip && this.refDocumentaleZip != null) {
      this.helpers.downloadZipFile(this.refDocumentaleZip).subscribe({
        next: (response: HttpResponse<Blob>) => {
          const blob = response.body;
          //Nome personalizzato al file zip
          const nomeFile = 'estrazione_massiva_documenti_' + this.ctxBodyFascicolo.fascicolo.posizione + '.zip';
          saveAs(blob, nomeFile);
          this.downloadState = 'nessuno';
        },
        error: (error) => {
          if (error.status === 500) {
            console.error('Errore durante il download (500):', error);    
            this.downloadState = 'completo';
          } else {
            console.error('Errore durante il download:', error);
            this.downloadState = 'completo';     
          }
        }
      });
    } 
  }


  getDocumentazione() {
    // this.idFascicolo = params['idFascicolo'];
    if (!this.tipoPratica) {
      this.frontEndMapping
        .getListTipiPratica(this.getTipoPratica())
        .subscribe((res) => {
          this.tipoPratica = res;
          this.getListDocumentazione();
        });
    } else {
      this.getListDocumentazione();
    }
  }

  getListDocumentazione() {
    this.operationService
      .getDocumentazione(this.tipoPratica, this.idFascicolo)
      .subscribe((readSezioneResponse) => {
        this.prepareTreeView(readSezioneResponse);
        if (this.cartellaCorrente) {
          this.selezionaCartellaCorrente(this.cartellaCorrente);
        }
      });
  }

  selezionaCartellaCorrente(cartella: FileFolders) {
    if (!this.treeData) {
      //console.log("treeData non è definito");
      return;
    }

    const pathTarget = cartella.path || '';
    let cartellaTrovata: FileFolders | null = null;

    if (cartella.root && !pathTarget) {
      cartellaTrovata = this.treeData.find(folder =>
        folder.name.toLowerCase() === cartella.name.toLowerCase()
      ) || null;
    } else {
      cartellaTrovata = this.findFolderByPath(this.treeData, pathTarget);
    }

    if (cartellaTrovata) {
      this.itemSelected = cartellaTrovata;
      //console.log("Cartella ripristinata:", cartellaTrovata.name);
    } else {
      console.log("Cartella non trovata per path:", pathTarget);
    }
  }


  findFolderByPath(folders: FileFolders[], path: string): FileFolders | null {
    for (let folder of folders) {
      if (folder.path === path) {
        return folder;
      }

      if (folder.children?.length) {
        const found = this.findFolderByPath(folder.children, path);
        if (found) return found;
      }
    }

    return null;
  }



  openProtocolDocumentsSelection(documento) {
    let arrayDocs = [];
    this.ctxBodyFascicolo.descrittori.forEach(descrittore => {
      let nomeSezione;
      if(descrittore.entitySimpleName === "SezioneDocumentazioneAllegata") {
        nomeSezione = "documentiFascicolo"
      } else {
        nomeSezione = descrittore.entitySimpleName.replace("Sezione", "documenti");
      }
      if(this.listDocumentazione[nomeSezione] && this.listDocumentazione[nomeSezione].length > 0) {
        arrayDocs = [...arrayDocs, ...this.listDocumentazione[nomeSezione]]
      }
    })
    let filteredDocs = arrayDocs.filter(el => el.numeroProtocollo === null && (!!el.refDocumentale || !!el.missingFile) && el.id !== documento.id);
    if (filteredDocs.length>0) {
      const ref = this.dialog.open(ProtocolDocumentSelectionComponent, {
        data: {
          style: { width: "50%" },
          title: 'Desideri selezionare uno o più allegati da associare a questo protocollo ?',
          documents: filteredDocs
        }
      });
      ref.afterClosed.subscribe(event => {
        if(!event || event.closeEvent) {
          documento.primary = false;
          return
        };
        if(event.modalEvent === true) {
          this.displayProtocolDocModal(documento, event.selectedDocuments);
        }
      });
    }
    else  this.displayProtocolDocModal(documento);
  }

  prepareTreeView(listDocumentazione) {
    this.treeData = [];
    this.listDocumentazione = listDocumentazione;
    this.separatorePathLogico = listDocumentazione.separatorePathLogico;
    const dirFolder: Array<FileFolders>[] = [];
    this.ctxBodyFascicolo.descrittori.forEach((descrittore, i) => {
      const sezione = {
        ...this.sezioni.find((sez) => sez.esn === descrittore.entitySimpleName),
      };
      if (sezione.esn) {
        const nomeSezione = sezione.esn.replace("Sezione", ""); // descrittore.entitySimpleName.replace('Sezione', '');
        let documentiSezione = listDocumentazione["documenti" + nomeSezione]
          ? listDocumentazione["documenti" + nomeSezione]
          : [];
        if (nomeSezione === "DocumentazioneAllegata") {
          sezione.nomeSezione = "Documentazione fascicolo";
          documentiSezione = listDocumentazione["documentiFascicolo"]
            ? listDocumentazione["documentiFascicolo"]
            : [];
        }
        dirFolder[sezione.nomeCampoId] = new Array<FileFolders>();
        if (nomeSezione !== "DocumentazioneAllegata") {
          documentiSezione.forEach((doc) => {
            const index = dirFolder[sezione.nomeCampoId].findIndex(
              (el) => el.code === doc.entitaCollegata.id
            );
            if (index > -1) {
              // esiste l'entità collegata
              dirFolder[sezione.nomeCampoId][index].children.push(
                new FileFolders(
                  doc.nomeFile,
                  doc.id,
                  null,
                  false,
                  doc.nomeFile,
                  doc.dataAggiornamento,
                  doc,
                  sezione
                )
              );
            } else {
              const d: FileFolders = new FileFolders(
                doc.entitaCollegata.titolo,
                doc.entitaCollegata.id,
                [
                  new FileFolders(
                    doc.nomeFile,
                    doc.id,
                    null,
                    false,
                    doc.nomeFile,
                    doc.dataAggiornamento,
                    doc,
                    sezione
                  ),
                ],
                false,
                doc.entitaCollegata.titolo,
                doc.dataAggiornamento,
                { ...doc, refDocumentale: null },
                sezione
              );
              dirFolder[sezione.nomeCampoId].push(d);
            }
          });
        } else {
          const tempDirFolder: Array<FileFolders>[] = [];
          const mapFolder = new Map();
          documentiSezione.forEach((doc, index) => {
            const isDir = !!doc.refDocumentale;
            const entityArray = doc.nomeFile.split(this.separatorePathLogico);
            const nomeFileDir = this.getNameFileDir(doc.nomeFile);

            if (!tempDirFolder[entityArray.length]) {
              tempDirFolder[entityArray.length] = new Array<FileFolders>();
            }
            tempDirFolder[entityArray.length].push(
              new FileFolders(
                nomeFileDir,
                doc.id,
                null,
                false,
                doc.nomeFile,
                doc.dataAggiornamento,
                doc,
                sezione
              )
            );
            mapFolder.set(
              entityArray.length,
              tempDirFolder[entityArray.length]
            );
          });

          /*mapFolder.forEach( (value, key, map) => {
          console.log(key);
          console.log(value);
        });*/
          for (let index = 1; index <= mapFolder.size; index++) {
            mapFolder.get(index).forEach((folder) => {
              if (
                folder.documento.refDocumentale === null
              ) {
                // directory di primo livello
                if (!folder.children) {
                  folder.children = new Array<FileFolders>();
                }
                const folderChildArray = this.getFolderChild(
                  mapFolder,
                  folder,
                  index
                );

                folder.children.push(...folderChildArray);
              }
            });
          }

          if (mapFolder.size > 0) {
            dirFolder[sezione.nomeCampoId].push(...mapFolder.get(1)); // aggiungo i primi livelli contentnei anche i sotto child
          }
          /** Creo una lista di documenti estraendoli dall'alberatura */
          this.extractDocumentsFromTreeview(dirFolder);
        }
        this.treeData.push(
          new FileFolders(
            sezione.nomeSezione,
            sezione.nomeCampoId,
            dirFolder[sezione.nomeCampoId],
            true,
            "",
            null,
            null,
            sezione
          )
        );
      }
    });
    this.demoData = new TreeModel(
      "code",
      "name",
      "children",
      this.treeData,
      null,
      true,
      "Navigazione",
      "demoData_folderStructure",
      "glyphicon-folder-close",
      "glyphicon-folder-open",
      "glyphicon-file"
    );

    if (this.searchIdDoc) {
      this.treeData.forEach((el) => {
        if (
          el.children &&
          el.children.length > 0 &&
          el.children[0].children &&
          el.children[0].children.findIndex(
            (e) => e.documento.id === this.searchIdDoc
          ) > -1
        ) {
          this.itemSelected = el.section.isMain ? el : el.children[0];
        }
      });
      if (!this.itemSelected) {
        this.itemSelected = null;
      }
      this.searchIdDoc = "";
    } else {
      this.itemSelected = this.itemSelected
        ? this.treeData.find(
            (el) => el.code === this.itemSelected.section.nomeCampoId
          )
        : null;
    }
    this.refreshData = true;
  }

  goSectionRoot(sectionRootId) {
    // this.itemSelected.section.nomeCampoId
    this.itemSelected = this.treeData.find((el) => el.code === sectionRootId);
    this.refreshData = true;
  }

  goSectionChild(objPath) {
    let navigatorItemParent = this.treeData.find((el) => el.code === objPath.sectionRootId);
    let navigatorItem = navigatorItemParent;

    objPath.itemPath.split(this.separatorePathLogico).forEach(pathElement => {
      navigatorItem.children.forEach(file => {
      if(file.name === pathElement && (file.documento && (!file.documento.refDocumentale || file.documento.missingFile))) {
          navigatorItemParent = navigatorItem;
          navigatorItem = file;
        }
      })
    });

    this.itemSelected = navigatorItem;
    this.refreshData = true;
  }

  setRefreshData(refresh) {
    this.refreshData = refresh;
  }

  

  getFolderChild(mapFolder, folder, index) {
    if (!mapFolder.get(index + 1)) {
      return [];
    }
    const folderChildArray = mapFolder.get(index + 1).filter((subFolder) => {
      return folder.path == this.extractPathBeforeLastSlash(subFolder.path);
    });
    return folderChildArray;
  }

  setItemSelected(item) {
    this.itemSelected = item;
    console.log("Selected: ", item);
  }

  extractPathBeforeLastSlash(path: string): string {
    const lastSlashIndex = path.lastIndexOf('/');
    if (lastSlashIndex === -1) {
      return "";
    }
    return path.substring(0, lastSlashIndex);
  }


  ctxBodyTaked(ctxBodyAbstract: CtxBodyAbstract) {
    if (!this.ctxBodyFascicolo) {
      this.ctxBodyFascicolo = <CtxBodyFascicolo>ctxBodyAbstract;
      this.nextStepWizard = this.getNextStepWizard();
      this.fascicolo = this.ctxBodyFascicolo.fascicolo;
      this.routingService.checkStatoFascicolo(
        this.ctxBodyFascicolo.fascicolo,
        this.getTipoPratica(),
        this.getTipoFascicolo(),
        this.nomePagina,
        true,
        null,
        this.wizard
      );
      //    if (this.ctxBodyFascicolo.fascicolo) {
      //      this.nextStepWizard = '/' + this.getNextStepWizard() + '/' + this.ctxBodyFascicolo.fascicolo.id;
      //    }
      let isDocumentazioneAllegataReadable: boolean = false;
      if (this.ctxBodyFascicolo.descrittori) {
        for (let descrittore of this.ctxBodyFascicolo.descrittori) {
          if (
            !this.routingService.isFascicoloWritable(
              this.ctxBodyFascicolo.fascicolo.praticaBase
            )
          ) {
            descrittore.writable = false;
          }
          if (
            descrittore.entitySimpleName ===
              NomiDescrittoriSezione.SEZIONE_DOCUMENTAZIONE_ALLEGATA_FASCICOLO &&
            descrittore.readable
          ) {
            isDocumentazioneAllegataReadable = true;
          }
        }
      }

      if (
        isDocumentazioneAllegataReadable &&
        this.ctxBodyFascicolo.descrittori
      ) {
        // debugger;
        this.descrittoriSezione = this.ctxBodyFascicolo.descrittori;
        let i = 0;
        for (let descrittore of this.ctxBodyFascicolo.descrittori) {
          // START FOR
          for (let idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
            // if (
            //   !(
            //     this.ctxBodyFascicolo.fascicolo.tipoFascicolo.endpoint ===
            //       "parere" && idDescrittore.nomeCampoId === "idSezioneAtti"
            //   )
            // ) {
              // todo: da fare a livello di permessi/descrittori

              if (
                descrittore.readable &&
                descrittore.entitySimpleName === idDescrittore.esn
              ) {
                this.sezioni[i] = [];
                if (
                  idDescrittore.nomeCampoId ===
                  "idSezioneDocumentazioneAllegata"
                ) {
                  this.sezioni[i]["isMain"] = true;
                } else {
                  this.sezioni[i]["isMain"] = false;
                }
                this.sezioni[i]["writable"] = descrittore.writable;
                this.sezioni[i]["esn"] = idDescrittore.esn;
                this.sezioni[i]["nomeCampoId"] = idDescrittore.nomeCampoId;
                this.sezioni[i]["nomeSezione"] =
                  idDescrittore.nomeCampoId === "idSezioneScadenze"
                    ? this.titleScadenze
                    : idDescrittore.nomeCampoId === "idSezioneControparti"
                    ? this.titleControparti
                    : idDescrittore.nomeCampoId === "idSezioneAltreParti"
                    ? this.titleAltreParti
                    : idDescrittore.nomeSezione.charAt(0).toUpperCase() +
                      idDescrittore.nomeSezione.slice(1);
                this.sezioni[i]["tipoPraticaId"] = this.getTipoPratica();
                this.sezioni[i]["praticaId"] =
                  this.ctxBodyFascicolo.fascicolo.idParent;
                this.sezioni[i]["posizionePratica"] =
                  this.ctxBodyFascicolo.fascicolo.praticaBase.posizione;
                this.sezioni[i]["fascicoloId"] =
                  this.ctxBodyFascicolo.fascicolo.id;
                this.sezioni[i]["posizioneFascicolo"] =
                  this.ctxBodyFascicolo.fascicolo.intestazione.campi.posizione;
                this.sezioni[i]["documenti"] = [];
                this.sezioni[i]["tipoSezione"] = new TipoSezione();
                this.sezioni[i]["entities"] = false;
                this.sezioni[i][idDescrittore.nomeCampoEntityList] = [];
                i++;
              }
            // }
          }
        } // END FOR
        this.getSezioni(this.sezioni);
      }
    }
  }

  getSezioni(sezioni) {
    for (let sezione of sezioni) {
      if (this["ctxBodyFascicolo"]["fascicolo"][sezione["nomeCampoId"]]) {
        sezione["id"] =
          this["ctxBodyFascicolo"]["fascicolo"][sezione["nomeCampoId"]];
        let url = this["readUrlArray"][sezione["nomeCampoId"]];
        this.readSezione(
          url,
          this["ctxBodyFascicolo"]["fascicolo"][sezione["nomeCampoId"]],
          sezione["esn"]
        );
      } else {
        if (sezione) {
          sezione["id"] = PropertiesSettings.NEW_SEZIONE;
        }
      }
    }
    this.getDocumentazione();
  }

  readSezione(url: string, idSezione: string, esn: string) {
    if (idSezione != PropertiesSettings.NEW_SEZIONE) {
      this.operationService
        .readSezione(url, idSezione)
        .subscribe((readSezioneResponse) =>
          this.setDocumenti(readSezioneResponse, esn)
        );
    }
  }

  setDocumenti(readSezioneResponse, esn) {
    // debugger
    for (let idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
      if (idDescrittore.esn === esn) {
        for (let sezione of this.sezioni) {
          if (sezione.id === readSezioneResponse.sezione.id) {
            sezione.documenti = readSezioneResponse.sezione.documentiAggregati;
            sezione[idDescrittore.nomeCampoEntityList] =
              readSezioneResponse["sezione"][idDescrittore.nomeCampoEntityList];
            sezione.tipoSezione = readSezioneResponse.sezione.tipoSezione;
            sezione.entities =
              sezione[idDescrittore.nomeCampoEntityList].length > 0;
          }
        }
      }
    }
  }

  ngOnDestroy() {
    this.subscriptionFascicolo.unsubscribe();
    if (this.subscriptionIntestazioneFascicolo) {
      this.subscriptionIntestazioneFascicolo.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionListDocumentazione) {
      this.subscriptionListDocumentazione.unsubscribe();
    }
    this.viewManager.completeBody();
    clearInterval(this.downloadPolling);
  }

  refresh(response) {
    const itemSelected = this.itemSelected;
    // console.log("itemSelected", itemSelected);
    if (itemSelected) {
      this.cartellaCorrente = itemSelected;
      // console.log("Cartella corrente salvata:", this.cartellaCorrente);
    }
    if (response.sezione) {
      let esn = "SezioneDocumentazioneAllegata";
      this["ctxBodyFascicolo"]["fascicolo"]["idSezioneDocumentazioneAllegata"] =
        response.sezione.id;
      this.readSezione(
        this["readUrlArray"]["idSezioneDocumentazioneAllegata"],
        response.sezione.id,
        esn
      );
      for (let sezione of this.sezioni) {
        if (sezione.esn === esn) {
          sezione.id = response.sezione.id;
        }
      }
    } else {
      for (let sezione of this.sezioni) {
        this.readSezione(
          this["readUrlArray"][sezione.nomeCampoId],
          sezione.id,
          sezione.esn
        );
      }
    }
    this.refreshData = false;
    this.getListDocumentazione();
  }

  refreshAfterUploadNewVersion(documento: DocumentoAllegato) {
    if ('primary' in documento) {
      delete (documento as any).primary;    
    }
    let request: UpdateMetadatiDocumentoRequest =
      new UpdateMetadatiDocumentoRequest();
    request.documento = documento;
    request.dataInput = new DataInput(
      this.fascicolo.praticaBase.id,
      this.fascicolo.id,
      this.fascicolo.praticaBase.intestazione.campi.posizionePratica,
      this.fascicolo.posizione,
      this.tipoPratica
    );

    this.operationService
      .updateMetadatiDocumento(request)
      .subscribe((response) => this.docUpdated(response));
  }

  from(event) {
    console.log("From: ", event);
    this.docToMove = event;
  }

  to(event) {
    console.log("To: ", event);
    const fileFoldersTo: FileFolders = event;
    const itemSelectedOriginale = this.itemSelected;
    this.fileFoldersTo = fileFoldersTo;
    if (
      this.docToMove.path === this.fileFoldersTo.path ||
      !this.fileFoldersTo.section.isMain
    ) {
      // same dir 'inizio' 'fine' || dir 'fine' is section
      this.refreshData = true;
      return;
    }
    if (!this.docToMove.documento.refDocumentale || this.docToMove.documento.missingFile) {
      // is directory in 'Documentazione Fascicolo' -> rename dir
      this.renameDirToMove();
      return;
    }
    const sectionFrom =
      this.docToMove.section.isMain && itemSelectedOriginale
      ? itemSelectedOriginale.section
      : this.docToMove.section;

    if (
      this.docToMove &&
      this.docToMove.section.isMain &&
      fileFoldersTo.section.isMain
    ) {
      // sposto file dentro sezione documentazione fascicolo
      this.updateMetadatiDocumento(this.docToMove, fileFoldersTo);
    } else {
      this.displayMoveDocModalDrop(this.docToMove, sectionFrom, fileFoldersTo);
    }
    this.itemSelected = null;
    this.fileFoldersTo = null;
  }

  renameDirToMove() {
    let doc: DocumentoAllegato;
    const nomeDir = this.getNameFileDir(this.docToMove.documento.nomeFile);
    const nomeFile =
      this.fileFoldersTo.path + this.separatorePathLogico + nomeDir;
    doc = {
      ...this.fileFoldersTo.documento,
      nomeFile,
      titolo: nomeFile,
    };
    this.operationService
      .updateMetadatiDir(
        this.getUrlAddDocToDocumentazioneAllegata(),
        doc,
        this.fileFoldersTo.section.id
      )
      .subscribe((response) => {
        this.docUpdated(response);
        this.refreshData = false;
        this.getListDocumentazione();
      });
  }

  getNameFileDir(nameFile) {
    return nameFile.split(this.separatorePathLogico).slice(-1)[0];
  }

  docUpdated(response) {
    for (let sezione of this.sezioni) {
      this.readSezione(
        this["readUrlArray"][sezione.nomeCampoId],
        sezione.id,
        sezione.esn
      );
    }
  }

  displayMoveDocModal(event, sezione) {
    this.docSpostaModal.initForm(
      sezione,
      this.sezioni,
      this.ctxBodyFascicolo.fascicolo.id,
      event
    );
  }

  displayMoveDocModalDrop(
    docToMove: FileFolders,
    sectionFrom: Sezione,
    fileFoldersTo: FileFolders
  ) {
    // this.docSpostaModal.initForm(sezione, this.sezioni, this.ctxBodyFascicolo.fascicolo.id, event);
    if (docToMove && fileFoldersTo && fileFoldersTo.section && sectionFrom) {
      const formTitle =
        "Sposta documento - " + fileFoldersTo.section.nomeSezione;
      const objMoveDoc = {
        idDocumento: docToMove.documento.id,
        tipoSezioneDestinazione: fileFoldersTo.section.tipoSezione,
        tipoSezioneSorgente: sectionFrom.tipoSezione,
      };

      this.displayAddDocModal(formTitle, fileFoldersTo, objMoveDoc, true);
      this.itemSelected = null;
      // this.displayAddDocModal(event.formTitle, event.sezione, event.request, true);
    }
  }

  updateMetadatiDocumento(
    documentoUpdated: FileFolders,
    fileFoldersTo: FileFolders
  ) {
    let request: UpdateMetadatiDocumentoRequest =
      new UpdateMetadatiDocumentoRequest();
    request.documento = {
      ...documentoUpdated.documento,
      nomeFile:
        fileFoldersTo.path +
        (fileFoldersTo.path !== "" ? this.separatorePathLogico : "") +
        this.getNameFileDir(documentoUpdated.documento.nomeFile),
    };
    request.dataInput = new DataInput(
      this.fascicolo.praticaBase.id,
      this.fascicolo.id,
      this.fascicolo.praticaBase.intestazione.campi.posizionePratica,
      this.fascicolo.posizione,
      this.tipoPratica
    );

    this.operationService
      .updateMetadatiDocumento(request)
      .subscribe((response) => {
        this.docUpdated(response);
        this.refreshData = false;
        this.getListDocumentazione();
      });
    this.itemSelected = null;
  }

  displayDetailFromProtocol(document: ResponseDocumentProtocol) {
    this.ctxBodyFascicolo.fascicolo.numeroFascicoloProtocollo = this.ctxBodyFascicolo.fascicolo.numeroFascicoloProtocollo ? this.ctxBodyFascicolo.fascicolo.numeroFascicoloProtocollo : document.dossierNumber;
    this.ctxBodyFascicolo.fascicolo.praticaBase.numeroFascicoloProtocollo =this.ctxBodyFascicolo.fascicolo.praticaBase.numeroFascicoloProtocollo ?this.ctxBodyFascicolo.fascicolo.praticaBase.numeroFascicoloProtocollo : document.dossierNumber;
    this.ctxBodyFascicolo.fascicolo.numeroProtocollo =  this.ctxBodyFascicolo.fascicolo.numeroProtocollo ?  this.ctxBodyFascicolo.fascicolo.numeroProtocollo : document.protocolNumber;
    this.ctxBodyFascicolo.fascicolo.praticaBase.numeroProtocollo = this.ctxBodyFascicolo.fascicolo.praticaBase.numeroProtocollo ? this.ctxBodyFascicolo.fascicolo.praticaBase.numeroProtocollo : document.protocolNumber;
    this.fascicolo.numeroFascicoloProtocollo = this.fascicolo.numeroFascicoloProtocollo ? this.fascicolo.numeroFascicoloProtocollo : document.dossierNumber;
    this.ctxBodyFascicolo.fascicolo.senderReceiver =  this.ctxBodyFascicolo.fascicolo.senderReceiver ?  this.ctxBodyFascicolo.fascicolo.senderReceiver : document.senderReceiver;
    this.detailDocument.showDetailModal(document.document)
  }

  displayDocVersionUpdateModal(documento: DocumentoAllegato) {
    this.docVersionUpdateModal.initForm(documento);
  }

  displayDocVersionHistoryModal(documento: DocumentoAllegato) {
    this.docVersionHistoryModal.initContent(documento, this.fascicolo);
  }

  displayDocUpdateMetadatiModal(documento: DocumentoAllegato, folder?) {
    const ref = this.dialog.open(UpdateMetadatiComponent, {
      data: {
        style: { width: "70%"},
        title: 'Modifica metadati',
        documento: documento,
        fascicolo: this.ctxBodyFascicolo?.fascicolo,
        tipoPratica: this.getTipoPratica()
      }
    });
     ref.afterClosed.subscribe(event => {
      if(!event || event.closeEvent) {
        // documento.primary = false;
        return
      };
      if(!!event.response) {
        this.refresh(event.response);
      }
    });
  }

   displayProtocolDocModal(documento: DocumentoAllegato, documenti?: DocumentoAllegato[]) {
    let docList = [...[documento], ...(documenti || [])];
    // this.docProtocolModal.initForm(documento,this.fascicolo.id, docList);
    const ref = this.dialog.open(ProtocolFascicoloInsertComponent, {
      data: {
        style: { width: "70%"},
        title: 'Nuovo Protocollo',
        protocol: {
          isDocumentInserted: true,
          listaDocumenti: docList,
          documento: documento
        }
      }
    });
    ref.afterClosed.subscribe(event => {
      if(!event || event.closeEvent) {
        documento.primary = false;
        return
      };
      if(!!event.protocol === true) {
        this.protocolservice.protocolDocument(event.protocol,this.idFascicolo).subscribe(res => {
          documento.numeroProtocollo = res.metadata.sigla + '/' + res.metadata.protocolYear + '/' + res.metadata.protocolNumber;
          let docProtocol:ResponseDocumentProtocol={document:documento, dossierNumber:res.metadata.dossierNumber, protocolNumber:res.metadata.protocolNumber}
          this.openProtocolConfirmDialog();
          this.refresh(docProtocol);
        });
      }
    });
  }

  getSezione(sezione) {
    this.esn = sezione;
  }

  onSelectCategoriaDocumento(event) {
    this.displayAddDocModalOld(
      event.formTitle,
      event.sezione,
      event.request,
      true
    );
  }

  onDocumentoSpostato(event) {
    this.docSpostaModal.manageModal(event);
    this.updateMetadatiDocumento(this.docToMove, this.fileFoldersTo);
    //this.modalNotifyService.customMessage('Operazione avvenuta con successo.');
  }

  displayAddDocModal(
    evt,
    fileFoldersTo = this.fileFoldersTo,
    request = null,
    isSpostaDoc = false
  ) {
    if (!fileFoldersTo) {
      fileFoldersTo = this.itemSelected;
    }
    let event = null;
    let fileList: DocumentoAllegato[] = [];
    if (evt && evt.event) {
      event = evt.event;
      fileList = evt.fileUploadList;
    } else {
      event = evt;
    }
    if (
      fileFoldersTo &&
      fileFoldersTo.section &&
      fileFoldersTo.section.isMain
    ) {
      // documentazione allegata
      this.docAddModal.initForm(
        this.getUrlAddDocToDocumentazioneAllegata(),
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request,
        fileList,
        fileFoldersTo,
        this.separatorePathLogico,
        null,
        null,
        null,
      );
    } else if (fileFoldersTo.root) {
      const url = this["insertUrlArray"][fileFoldersTo.section["nomeCampoId"]];
      this.docAddModal.initForm(
        url,
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request,
        fileList,
        null,
        null,
        null,
        null,
        null,
      );
    } else if (fileFoldersTo.section && fileFoldersTo.documento) {
      console.log("entity già associata");
      const url = this["insertUrlArray"][fileFoldersTo.section["nomeCampoId"]];
      const entitaCollegata = this.getEntity(
        fileFoldersTo.section,
        fileFoldersTo.documento.entitaCollegata.id
      );
      this.docAddModal.initForm(
        url,
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        true,
        entitaCollegata,
        isSpostaDoc,
        request,
        fileList,
        null,
        null,
        null,
        null,
        null,
      );
    }
  }

  exportFile(
    evt,
    fileFoldersTo = this.fileFoldersTo,
    request = null,
    isSpostaDoc = false
  ) {
    if (!fileFoldersTo) {
      fileFoldersTo = this.itemSelected;
    }
    let event = null;
    let fileList: DocumentoAllegato[] = [];
    if (evt && evt.event) {
      event = evt.event;
      fileList = evt.fileUploadList;
    } else {
      event = evt;
    }
    if (
      fileFoldersTo &&
      fileFoldersTo.section &&
      fileFoldersTo.section.isMain
    ) {
      // documentazione allegata
      this.docAddModal.initForm(
        this.getUrlAddDocToDocumentazioneAllegata(),
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request,
        fileList,
        fileFoldersTo,
        this.separatorePathLogico,
        null,
        null,
        null,
      );
    } else if (fileFoldersTo.root) {
      const url = this["insertUrlArray"][fileFoldersTo.section["nomeCampoId"]];
      this.docAddModal.initForm(
        url,
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request,
        fileList,
        null,
        null,
        null,
        null,
        null,
      );
    } else if (fileFoldersTo.section && fileFoldersTo.documento) {
      console.log("entity già associata");
      const url = this["insertUrlArray"][fileFoldersTo.section["nomeCampoId"]];
      const entitaCollegata = this.getEntity(
        fileFoldersTo.section,
        fileFoldersTo.documento.entitaCollegata.id
      );
      this.docAddModal.initForm(
        url,
        fileFoldersTo.section,
        fileFoldersTo.section.fascicoloId,
        fileFoldersTo.section.isMain,
        fileFoldersTo.section.esn,
        "Nuovo Documento",
        true,
        entitaCollegata,
        isSpostaDoc,
        request,
        fileList,
        null,
        null,
        null,
        null,
        null,
      );
    }
  }

  displayAddDocModalOld(event, sezione, request = null, isSpostaDoc = false) {
    if (sezione.isMain) {
      this.docAddModal.initForm(
        this.getUrlAddDocToDocumentazioneAllegata(),
        sezione,
        sezione.fascicoloId,
        sezione.isMain,
        sezione.esn,
        event,
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request
      );
    } else {
      let url = this["insertUrlArray"][sezione["nomeCampoId"]];
      this.docAddModal.initForm(
        url,
        sezione,
        sezione.fascicoloId,
        sezione.isMain,
        sezione.esn,
        event,
        this.addDocToEntity,
        null,
        isSpostaDoc,
        request
      );
    }
  }

  displayAddFolderModal(
    evt,
    sezione,
    request = null,
    isSpostaDoc = false,
    documento: DocumentoAllegato = null
  ) {
    this.docAddModal.initForm(
      this.getUrlAddDocToDocumentazioneAllegata(),
      sezione,
      sezione.fascicoloId,
      sezione.isMain,
      sezione.esn,
      "Nome cartella",
      this.addDocToEntity,
      null,
      isSpostaDoc,
      request,
      null,
      this.itemSelected,
      this.separatorePathLogico,
      true,
      documento,
      this.tipoPratica
    );
  }

  getEntity(sezione, idEntityCollegata) {
    let arrayList = [];
    for (const idDescrittore of IdDescrittoriDiSezione.TutteLeSezioni) {
      if (idDescrittore.esn === sezione.esn) {
        arrayList = sezione[idDescrittore.nomeCampoEntityList];
      }
    }
    return arrayList.find((el) => el.id === idEntityCollegata);
  }

  removeDocFromSezione(documento, sezione) {
    this.cartellaCorrente = this.cartellaCorrente ?? documento.folder ?? null;
    if (sezione.isMain) {
      this.operationService
        .removeDocumentoFromSezDocumentiAllegatiOrdinario(
          documento,
          this.getUrlRemoveDocFromDocumentazioneAllegata(),
          sezione.id
        )
        .subscribe((response) => {
          this.refresh(response);
          this.viewManager.updateIntestazione();
        });
    } else if (!sezione.isMain) {
      let url = this["deleteUrlArray"][sezione["nomeCampoId"]];
      this.operationService
        .removeDocumentoToEntity(documento, url, documento.entitaCollegata.id)
        .subscribe((response) => {
          this.refresh(response);
          this.viewManager.updateIntestazione();
        });
      }

    // this.currentPage = 0;
    // this.itemsPerPage = 10;
    // this.setCurrentDocList();
  }

  removeDocFromSezioneConFascicolo(event: { documento, nuovoFascicolo }, sezione) {
    const documento = event.documento;
    const nuovoFascicolo = event.nuovoFascicolo;
    this.cartellaCorrente = this.cartellaCorrente ?? documento.folder ?? null;
    const idFascicolo = nuovoFascicolo.idFascicolo; // dal nuovo fascicolo selezionato
    this.operationService.removeDocumentoConFascicolo(documento,sezione.id,idFascicolo)
    .subscribe(response => {
      this.refresh(response);
      this.viewManager.updateIntestazione();
    });
  }

  getUrlRemoveDocFromSezione() {
    let urlArray: Array<any> = [];
    for (let idDescrittori of IdDescrittoriDiSezione.TutteLeSezioni) {
      urlArray["idSezioneControparti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_CONTROPARTE;
      urlArray["idSezioneLegali"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_LEGALE_INCARICATO;
      urlArray["idSezioneAltreParti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ALTRAPARTE;
      urlArray["idSezioneAtti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ATTO;
      urlArray["idSezioneEsiti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ESITO;
      urlArray["idSezioneParcelle"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PARCELLA;
      urlArray["idSezioneFatture"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_FATTURA;
      urlArray["idSezioneIncassi"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_INCASSO;
      urlArray["idSezionePagamenti"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PAGAMENTO;
      urlArray["idSezioneScadenze"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_SCADENZA;
      urlArray["idSezioneProveScritte"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_PROVASCRITTA;
      urlArray["idSezioneTitoliEsecutivi"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_TITOLO_ESECUTIVO;
      urlArray["idSezioneBeniPignoratiMobili"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_BENEMOBILE;
      urlArray["idSezioneBeniPignoratiImmobili"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_BENEIMMOBILE;
        urlArray["idSezioneSchedeRecupero"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_SCHEDA_RECUPERO;
        urlArray["idSezioneSchedeEsecuzione"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_SCHEDA_ESECUZIONE;
      urlArray["idSezioneDatiPignoramento"] =
        ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_DATI_PIGNORAMENTO;
    }
    return urlArray;
  }

  getUrlAddDocument(): Array<string> {
    let urlArray: Array<any> = [];
    for (let idDescrittori of IdDescrittoriDiSezione.TutteLeSezioni) {
      urlArray["idSezioneControparti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_CONTROPARTE;
      urlArray["idSezioneLegali"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_LEGALE_INCARICATO;
      urlArray["idSezioneAltreParti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_ALTRAPARTE;
      urlArray["idSezioneAtti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_ATTO;
      urlArray["idSezioneEsiti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_ESITO;
      urlArray["idSezioneParcelle"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_PARCELLA;
      urlArray["idSezioneFatture"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_FATTURA;
      urlArray["idSezioneIncassi"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_INCASSO;
      urlArray["idSezionePagamenti"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_PAGAMENTO;
      urlArray["idSezioneScadenze"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_SCADENZA;
      urlArray["idSezioneProveScritte"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_PROVASCRITTA;
      urlArray["idSezioneTitoliEsecutivi"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_TITOLO_ESECUTIVO;
      urlArray["idSezioneBeniPignoratiImmobili"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_BENEIMMOBILE;
      urlArray["idSezioneBeniPignoratiMobili"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_BENEMOBILE;
      urlArray["idSezioneSchedeRecupero"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_SCHEDA_RECUPERO;
      urlArray["idSezioneSchedeEsecuzione"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_SCHEDA_ESECUZIONE;
      urlArray["idSezioneDatiPignoramento"] =
        ServicePathsSettings.URL_ADD_DOCUMENTO_TO_DATI_PIGNORAMENTO;
    }
    return urlArray;
  }

  getAddDocumentFormTitle(): Array<string> {
    let formTitleArray: Array<any> = [];
    for (let idDescrittori of IdDescrittoriDiSezione.TutteLeSezioni) {
      formTitleArray["idSezioneDocumentazioneAllegata"] = "Aggiungi documento";
      formTitleArray["idSezioneControparti"] =
        "Aggiungi documento - " + this.titleControparti; // Parte';
      formTitleArray["idSezioneLegali"] = "Aggiungi documento - Legale";
      formTitleArray["idSezioneAltreParti"] =
        "Aggiungi documento - " + this.titleAltreParti;
      formTitleArray["idSezioneAtti"] = "Aggiungi documento - Atto";
      formTitleArray["idSezioneEsiti"] = "Aggiungi documento - Esito";
      formTitleArray["idSezioneParcelle"] = "Aggiungi documento - Parcella";
      formTitleArray["idSezioneFatture"] = "Aggiungi documento - Fattura";
      formTitleArray["idSezioneIncassi"] = "Aggiungi documento - Incasso";
      formTitleArray["idSezionePagamenti"] = "Aggiungi documento - Pagamento";
      formTitleArray["idSezioneScadenze"] = "Aggiungi documento - Scadenza";
      formTitleArray["idSezioneProveScritte"] =
        "Aggiungi documento - Prova Scritta";
      formTitleArray["idSezioneTitoliEsecutivi"] =
        "Aggiungi documento - Titolo Esecutivo";
      formTitleArray["idSezioneBeniPignoratiImmobili"] =
        "Aggiungi documento - Bene Immobile";
      formTitleArray["idSezioneBeniPignoratiMobili"] =
        "Aggiungi documento - Bene Mobile";
        formTitleArray["idSezioneSchedeRecupero"] =
        "Aggiungi documento - Schede Recupero";
        formTitleArray["idSezioneSchedeEsecuzione"] =
        "Aggiungi documento - Schede Esecuzione";
        formTitleArray["idSezioneDatiPignoramento"] = "Aggiungi documento - Dati Pignoramento";
    }
    return formTitleArray;
  }

  fascicoloRefreshed(fascicolo: FascicoloFull) {
    this.ctxBodyFascicolo.fascicolo = fascicolo;
    this.fascicolo = fascicolo;
  }

  /*** UPLOAD FILE SERVICE ***/

  uploadFileService(files) {
    this.loading = true;
    for (let i = 0; i < files.length; i++) {
      this.uploadFile(files[i], Number(i) == files.length - 1);
    }
  }

  uploadFile(file: File, isLastOne?): Promise<any> {
    if (!file.type) {
      // Bthis.modalNotifyService.customMessage("Non è possibile fare l'upload di cartelle!");
      this.loading = false;
      return;
    }

    this.XSRF =  this.getXSRFToken()['XSRF-TOKEN']

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(
              (this.fileData = (<FileUploadResponse>(
                JSON.parse(xhr.response)
              )).fileData)
            );
            console.log("OK upload");
            this.setFileDataRequest(this.fileData);
            if (isLastOne) {
              this.loading = false;
              this.displayAddDocModal({
                event:
                  this.addDocFormTitles[this.itemSelected.section.nomeCampoId],
                fileUploadList: this.fileUploadList,
              }); // idSezioneDocumentazioneAllegata
            }
            // this.onReturn.emit(this.fileData);
          } else {
            console.log("KO upload");
            this.loading = false;
            // this.modalNotifyService.customMessage("L'operazione non è andata a buon fine.");
            reject(xhr.response);
          }
        }
      };
      xhr.open("POST", this.getXSRFToken()['XSRF-TOKEN'], true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("X-XSRF-TOKEN", this.XSRF);
      if(environment.SSO_STRATEGY.toLowerCase() === "oauth2") {
        xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('access_token')}`);
      }
      const formData = new FormData();
      formData.append("contenuto", file);
      formData.append("nomeFile", file.name);
      xhr.send(formData);
    });
  }

  getXSRFToken = () =>
  document.cookie.split('; ').reduce((acc, value) => {
    const cookie = value.split('=');
    acc[cookie[0]] = cookie[1];
    return acc;
  }, {});

  setFileDataRequest(fileData: FileData) {
    const fileDaAllegare = new DocumentoAllegato();
    fileDaAllegare.refDocumentale = fileData.refDocumentale;
    fileDaAllegare.nomeFile = fileData.nomeFile;
    fileDaAllegare.contentType = fileData.contentType;
    fileDaAllegare.contentSize = fileData.contentSize;
    this.fileUploadList.push(fileDaAllegare);
  }

  retrieveEventDocSigned(itemSelected: FileFolders){
    this.itemSelected = itemSelected;
    this.getListDocumentazione();
  }

  openProtocolConfirmDialog(){
    this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: "La protocollazione è andata a buon fine!",
          data: [],
          hideButtons: true,
          confirmButton :true
        },
        style: {
          width: '50%',
          zIndex: '9999999 !important'
        },
        title: 'Conferma',
      }
    });
  }

  onFilterSearch() {
    this.currentPage = 0;
    this.itemsPerPage = 10;
    /** VERIFICARE LA CRITICITà di questo blocco */
    this.currentDocList = this.tempDocList;
    this.docList = this.tempDocList;
    this.docListLength = this.docList.length;

    this.pagination.setCurrentPage(0);
    // this.setCurrentDocList();
    /** *** */
    this.filters = { ...this.filterForm.getRawValue() };
    this.filters = Object.fromEntries(
      Object.entries(this.filters).filter(([_, value]) => value !== null && value !== undefined)
    );
    let filtered = this.onDoFilter(this.docList)
    // this.currentDocList = [...filtered];
    this.docList = [...filtered];
    this.setCurrentDocList();
    this.docListLength = filtered.length;
  }

  private onDoFilter(list) {
    return list.filter(itm => {
      return Object.keys(this.filters).every(key => {
        if (key === "tipoDocumento") {
          return itm.documento[key].descrizione?.toLowerCase() === this.filters[key].toLowerCase();
        }
        if (key === "cartella") {
          if(!itm.documento.nomeFile.includes("/") && (itm.documento.refDocumentale || !itm.documento.missingFile)) return;
          const splitted = this.splitFileName(itm.documento);
          let index = splitted.findIndex(el => el.toLowerCase().includes(this.filters[key].toLowerCase()));
          return index > -1;
        }
        if(key === "dataRiferimentoFrom") {
          let dateFrom = this.getExactLocalDate(itm.documento.dataRiferimento);
          return dateFrom >= Number(this.filters[key]);
        }
        if(key === "dataRiferimentoTo") {
          let dateTo = this.getExactLocalDate(itm.documento.dataRiferimento);
          return dateTo <= Number(this.filters[key]);
        }
      });
    });
  }

  private getExactLocalDate(itm: number) {
    const timestamp = itm;
    const date = new Date(timestamp);
    date.setHours(0, 0, 0, 0); // Mezzanotte nel fuso locale
    let dateFrom = date.getTime();
    return dateFrom;
  }

  private splitFileName(itm: any) {
    const splitted = itm.nomeFile.split("/");
    let lastElement = splitted[splitted.length - 1];
    let isFile = this.hasValidExtension(lastElement);
    if (isFile) {
      splitted.pop();
    }
    return splitted;
  }

  hasValidExtension(file: string): boolean {
    return /\.[a-zA-Z0-9]{2,5}$/.test(file);
  }

  reset() {
    this.filterForm.reset();
    this.filters = {};
    this.currentDocList = this.tempDocList;
    this.docList = this.tempDocList;
    this.docListLength = this.docList.length;
    this.setCurrentDocList();
  }

  initForm() {
    this.questions = questions;
    let index = this.questions.findIndex(el => el.key === "tipoDocumento");
    this.tipiDocumentoOptions.forEach(el => el["value"] = el.label);
    this.questions[index].options = this.tipiDocumentoOptions;
    this.filterForm = this.qcs.toFormGroup(this.questions as QuestionBase[]);
  }

  truncate(text: string, chars:number) {
    if(!text) return;
    return text.length > chars ? text.slice(0, chars) + " ... " : text;
  }

  onRefresh(pagination: Pagination) {
    this.currentPage = pagination.getCurrentPage();
    this.itemsPerPage = pagination.getItemsPerPage();
    this.setCurrentDocList();
  }

  setCurrentDocList(){
    let currentIndex = this.currentPage * this.itemsPerPage;
    this.currentDocList = this.docList.slice(currentIndex, currentIndex + this.itemsPerPage);
  }

  sortColumn(column:string) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortData(column);
  }

  sortData(column): void {
    // this.currentDocList = [];
    this.currentDocList = [...this.docList].sort((a, b) => {
      if (!column) return 0;
      const valueA = a.documento[column];
      const valueB = b.documento[column];

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
    this.docList = [...this.currentDocList];
    this.setCurrentDocList();
  }

  extractChildren(data: any[]): any[] {
    let result: any[] = [];
    function recursiveExtract(items: any[]): void {
        for (let item of items) {
          result = [...result, ...[item]];
          if (item !== null) {
            for (const key in item) {
              if (key === 'children' && Array.isArray(item[key])) {
                result = [...result, ...item[key]];
                recursiveExtract(item[key]);
              }
            }
          }
        }
    }
    recursiveExtract(data);
    return result;
  }

  private extractDocumentsFromTreeview(dirFolder: FileFolders[][]) {
    let array = [];
    for (const [key, value] of Object.entries(dirFolder)) {
      array = [...array, ...this.extractChildren(value)];
    }
    const arrayNoDuplicates = Array.from(
      new Map(array.map(item => [item.code, item])).values()
    );
    /**FILTRO CHE RIMUOVE LE CARTELLE */
    let arrayFiltered = arrayNoDuplicates.filter(
      (item, index, self) => index === self.findIndex(
        obj => obj.documento.id === item.documento.id) && !!item.documento.refDocumentale || !!item.documento.entitaCollegata || !!item.documento.missingFile
    );
    /**FILTRO CHE RIMUOVE I DOCUMENTI DUPLICATI */
    const filteredNoDuplicates = Array.from(
      new Map(arrayFiltered.map(item => [item.documento.id, item])).values()
    );

    let sorted = filteredNoDuplicates.sort((a, b) => a.documento.dataRiferimento - b.documento.dataRiferimento);
    /** Mantiene l'ordinamento persistente se esso é cambiato in precedenza */
    if(this.sortDirection === "desc") {
      this.keepSortingPersistency(sorted);
    }
    this.currentDocList = sorted;
    this.docList = sorted;
    this.tempDocList = sorted;
    this.docListLength = sorted.length;
    this.cdr.detectChanges();
    this.pagination = new Pagination(sorted.length, this.itemsPerPage);
    this.setCurrentDocList();
  }

  private keepSortingPersistency(sorted: any[]) {
    sorted.sort((a, b) => {
      const valueA = a.documento["dataRiferimento"];
      const valueB = b.documento["dataRiferimento"];

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
    this.docList = [...sorted];
  }

  showDetailModal(documento) {
    this.docToDetail = documento;
    this.showDetail = true;
    openModal('docShowDetailModal');
    setTimeout(() => this.docShowDetailModal.nativeElement.focus());
  }

  closeDetailModal() {
    this.showDetail = false;
    closeModal('docShowDetailModal');
  }

  showDeleteDirModal(documento: DocumentoAllegato, folder) {
    this.docToRemove = documento;
    this.dirToRemove = folder;
    this.isEliminaDir = true;
    openModal('docShowEliminaDirModal');
    setTimeout(() => this.docShowEliminaDirModal.nativeElement.focus());
  }

  confermaEliminaDir() {
    this.removeDocFromSezione(this.docToRemove, this.dirToRemove.section);
    this.dirToRemove = null;
    this.docToRemove = null;
    closeModal('docShowEliminaDirModal');
    this.isEliminaDir = false;
  }

  openProtocolDisclaimer(documento) {
    documento.primary = true;
    this.openProtocolDocumentsSelection(documento);
  }

  firmaDoc(documento: DocumentoAllegato,itemSelected: FileFolders) {
    const ref = this.dialog.open(SignDocumentDialogComponent, {
      data: {
        document: documento,
        style: { width: "50%" }
      }
    })

    const sub = ref.afterClosed.subscribe(event => {
      if (event.modalEvent) {
        this.retrieveEventDocSigned(itemSelected);
      }
      sub.unsubscribe();
    });

  }


  timbraDoc(documento: DocumentoAllegato,itemSelected: FileFolders) {
    const ref = this.dialog.open(MarkDocumentDialogComponent, {
      data: {
        document: documento,
        idFascicolo: this.ctxBodyFascicolo.fascicolo.id,
        style: { width: "50%" }
      }
    })
  //Quando la modale viene chiusa, mi assicuro che l'evento modalEvent venga emesso
  // prima di eseguire onDocMarked.emit(itemSelected)
    const sub = ref.afterClosed.subscribe(event => {
      if (event.modalEvent) {
        // this.onDocMarked.emit(itemSelected);
      }
      sub.unsubscribe();
    });
  }

  annullaProtocolDoc(documento: DocumentoAllegato, itemSelected?: FileFolders) {
    if (!!documento.flagAttoPrincipale) {
      this.helpers.searchByProtocollo(documento.numeroProtocollo, false)
        .subscribe(result => {
          if (result && result.length > 0) {
            // ci sono altri fascicoli: apro la modale di selezione
            const messaggio = `Stai per annullare l’associazione del protocollo ${documento.numeroProtocollo} al fascicolo principale ${this.fascicolo.posizione}.`;
            const refSel = this.dialog.open(SelezioneFascicoliSecondariComponent, {
              data: {
                style: { width: "50%" },
                title: "Seleziona fascicolo ricevente",
                message: messaggio,
                fascicoliDisponibili: result ?? [],
                fascicoloCorrente: this.fascicolo // o il contesto che usi
              }
            });

            refSel.afterClosed.pipe().subscribe(event => {
              if (!event) return; // annullato
              if (event.modalEvent === true) {
                const selectedFascicolo = event.selectedFascicolo ?? null;
                // ora apro la modale di annullamento passando l'eventuale selectedFascicolo
                this.openAnnullaDialogWithTarget(documento,itemSelected, selectedFascicolo);
              }
            });
          } else {
            // nessun altro fascicolo: apro direttamente l'annulla dialog
            this.openAnnullaDialogWithTarget(documento,itemSelected, null);
          }
        });
    } else {
      // non è atto principale apro direttamente
      this.openAnnullaDialogWithTarget(documento, itemSelected, null);
    }
  }

  /**
   * Apro la modale di annullamento passandole un eventuale nuovo fascicolo destinatario.
   */
  private openAnnullaDialogWithTarget(documento: DocumentoAllegato, itemSelected:FileFolders, selectedFascicolo: any | null) {
    const ref = this.dialog.open(AnnullaDocumentoProtocolloComponent, {
      data: {
        document: documento,
        idFascicolo: this.ctxBodyFascicolo.fascicolo.id,
        style: { width: "50%" }
      }
    });

    const sub = ref.afterClosed.subscribe(result => {
      if (result?.modalEvent && result.data) {
        // result.data contiene estremiProvvedimento, dataAnnullamento, identificativoOperatore...
        const annullamento = result.data;
        documento.estremiProvvedimento = annullamento.estremiProvvedimento;
        documento.dataAnnullamento = annullamento.dataAnnullamento
          ? new Date(annullamento.dataAnnullamento).getTime()
          : new Date().getTime(); 
        documento.identificativoOperatore = annullamento.identificativoOperatore;
       
        const payload: any = {
          idDocumentoDaAnnullare: documento.id,
          idFascicolo: selectedFascicolo?.idFascicolo,
          idSezione: itemSelected.section.id,
          estremiProvvedimento: documento.estremiProvvedimento,
          dataAnnullamento: documento.dataAnnullamento,
          identificativoOperatore: documento.identificativoOperatore
        };
        this.operationService.annullaProtocollazione(payload).subscribe({
        next: (resp) => {
          this.refresh(resp);
        },
        error: (err) => {
          console.log('Errore annullamento protocollazione', err);
        }
      });
      }
      sub.unsubscribe();
    });
  }

  getNameFile(nameFile) {
    return nameFile.split(this.separatorePathLogico).slice(-1)[0];
  }

  composeFileName(sez, name, doc) {
    let sliced = name.split("/");
    let file;
    let directories;
    let starHtml = (doc && doc.flagAttoPrincipale && doc.numeroProtocollo) ? ` <span class="glyphicon glyphicon-star"></span>` : '';
    let completeName;
    if(!doc.refDocumentale && !doc.missingFile) {
      if(sliced.length > 1) {
        completeName = `<strong class="section-doc-allegata-table">${sez}</strong>: ${starHtml} <br>${this.chainDirectories(sliced)}`;
        return completeName;
      }
      return `<strong class="section-doc-allegata-table">${sez}</strong>: ${starHtml} <br> <span class="glyphicon glyphicon-folder-close"></span> ${this.truncate(name, 30)}`
    } else {
      if(sliced.length > 1) {
        file = sliced[sliced.length - 1];
        directories = [...sliced];
        directories.pop();
        completeName = `<strong class="section-doc-allegata-table">${sez}</strong>: ${starHtml} <br> ${this.chainDirectories(directories)} ${this.getFileIcon(doc)} ${this.truncate(file, 10)}`;
      } else {
        completeName = `<strong class="section-doc-allegata-table">${sez}</strong>: ${starHtml} <br> ${this.getFileIcon(doc)} ${this.truncate(name, 30)}`;
      }
      return completeName;
    }
  }

  getFileIcon(doc) {
    if(doc.flagTimbratura) {
      return '<img class="section-doc-allegata-timbratura" alt="Documento timbrato" src="img/documentMarked.png"/>'
    } else {
      return '<span class="glyphicon glyphicon-file"></span>';
    }
  }

  chainDirectories(dir: string[]) {
    let chain ="";
    dir.forEach(el => {
      if(!!el) {
        chain += `<span class="glyphicon glyphicon-folder-close"></span> ${this.truncate(el, 30)} / `;
      }
    })
    return chain;
  }

  canViewFile(documento: DocumentoAllegato){
    let maxPreviewSize = this.findMaxSizeByContentype(documento.contentType);
    // controllo che il contenuto del file non superi la dimensione massima consentita
    // console.log(documento.contentSize, Number(maxPreviewSize))
    if(documento.contentSize > Number(!!maxPreviewSize ? maxPreviewSize : documento.contentSize)) {
      return false;
    };
    return documento && 
    documento.nomeFile && (
      documento.nomeFile.includes(".pdf") || 
      documento.nomeFile.includes(".eml") || 
      documento.nomeFile.includes(".zip") || 
      documento.nomeFile.includes(".p7m")
    );
  }

  checkMaxLimitExceeded(documento: DocumentoAllegato):boolean {
    let maxPreviewSize = this.findMaxSizeByContentype(documento.contentType);
    if(documento.contentSize > Number(!!maxPreviewSize ? maxPreviewSize : documento.contentSize)) {
      return true;
    }
    return false;
  }

  findMaxSizeByContentype(contentType) {
    let maxPreviewSize = UserProfileFlagStore.getInstance().MAX_PREVIEW_FILE_SIZE;
    if(!maxPreviewSize) return null;
    for (const key in maxPreviewSize) {
        if (maxPreviewSize[key].contentType === contentType) {
            return maxPreviewSize[key].maxSize;
        }
    }
    return maxPreviewSize['default'].maxSize;
  }

  viewDoc(documento: DocumentoAllegato) {
    const filename = documento.nomeFile;
    const extension = filename.substring(filename.lastIndexOf('.') + 1);
    let mimeTypes = mimeExtensionMap;
    this.previewNavigate(documento, mimeTypes[documento.contentType] || extension);
  }

  previewNavigate(documento: DocumentoAllegato, contentType: string) {
    let fullUrl = null;
    let urlTree = null;
    let urlSerialized = null;
    switch (contentType) {
      case EXTENSIONS.EML:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_EML_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.ZIP:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_ZIP_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.PDF:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_PDF_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.P7M:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_PDF_FILE_PREVIEW, documento.id, 'p7m']);
        break;
      default:
        break;
    }
    if(!urlTree) return;
    urlSerialized = this.router.serializeUrl(urlTree);
    let nomeFile = encodeURIComponent(documento.nomeFile);
    fullUrl = `${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#${urlSerialized}?nomeFile=${nomeFile}`;
    window.open(fullUrl, '_blank');
  }

  isFilePresent(documento): boolean {
     return documento?.missingFile !== true;
  }



  // viewDoc(idDocumento: string){
  //   const ref = this.dialog.open(ViewDocumentDialogComponent, {
  //     data: {
  //       document: idDocumento,
  //       style: {
  //         width: '75%',
  //       },
  //       title: 'Visualizzazione Documento',
  //     }
  //   });
  //   const sub = ref.afterClosed.subscribe(() => {
  //     sub.unsubscribe();
  //   });
  // }

  handleAnnullamento(resp: any) {
    this.refresh(resp);
  }

  hasFirmaNonValida(documento: DocumentoAllegato): boolean {
    if (!documento) return false;
    if (documento.statoDocumento !== 'FORMATO') {
      return false;
    }
    const firme = documento.metadatoFirmaDocumenti;
    if (!Array.isArray(firme) || firme.length === 0) {
      return false;
    }
    return firme.some(f => f.esitoVerifica.id === 'NON_VALIDA');
  }


}


export const questions = [
  {
    controlType: FormFieldType[FormFieldType.SEARCHABLE_DROPDOWN],
    key: "tipoDocumento",
    label: "Tipo Documento",
    placeholder: "Selezionare tipo documento",
    chips: false,
    disabled: false,
    required: false,
    size: "col-sm-3"
  },
  {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "cartella",
    label: "Cartella",
    placeholder: "Inserire cartella",
    chips: false,
    disabled: false,
    required: false,
    size: "col-sm-3"
  },
  {
    controlType: FormFieldType[FormFieldType.DATE],
    key: "dataRiferimentoFrom",
    label: "Data riferimento da",
    placeholder: "Selezionare inizio data riferimento",
    chips: false,
    disabled: false,
    required: false,
    size: "col-sm-3"
  },
  {
    controlType: FormFieldType[FormFieldType.DATE],
    key: "dataRiferimentoTo",
    label: "Data riferimento a",
    placeholder: "Selezionare fine data riferimento",
    chips: false,
    disabled: false,
    required: false,
    size: "col-sm-3"
  },
];
